import {useSyncExternalStore} from "react";

const STORAGE_KEY = "recent-activity";
const MAX_ITEMS = 3;

const read = () => {
    try {
        const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY));
        return Array.isArray(parsed) ? parsed : [];
    } catch {
        return [];
    }
};

let items = read();
const listeners = new Set();

const emit = () => listeners.forEach((listener) => listener());

export const recordActivity = (entry) => {
    if (!entry?.to || !entry?.title) return;
    if (items[0]?.to === entry.to) return;

    items = [{title: entry.title, to: entry.to}, ...items.filter((i) => i.to !== entry.to)].slice(0, MAX_ITEMS);

    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch {
        // ignore storage unavailability
    }

    emit();
};

const subscribe = (listener) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
};

const getSnapshot = () => items;

export const useRecentActivity = () => useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
